import React from 'react';
import { useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import moment from 'moment';

import Stack from '@mui/material/Stack';

import Form, { FormTextField, FormCheckbox, FormDateTimeSelector } from '@ts-core/core/components/FormV2';

import { Media } from '../../types';
import { MediaFormInput } from '../../types/form';

interface MediaFormProps {
  media: Media;

  submitting: boolean;
  submitError?: string;

  onSubmit: (data: MediaFormInput) => void;
}

const MediaForm = (props: MediaFormProps) => {
  const intl = useIntl();
  const { media, submitting, submitError, onSubmit } = props;
  const { handleSubmit, control, formState, watch } = useForm<MediaFormInput>({
    defaultValues: {
      name: media.name,
      availableFrom: media.availableFrom,
      availableUpTo: media.availableUpTo,
      withExpiration: !!media.availableFrom,
    },
  });
  const withExpiration = watch('withExpiration');
  const availableFrom = watch('availableFrom');

  return (
    <Form onSubmit={handleSubmit(onSubmit)} isSubmitting={submitting} submitError={submitError} formState={formState} sx={{ width: '100%' }}>
      <FormTextField
        control={control}
        rules={{ required: true }}
        name="name"
        label={intl.formatMessage({ id: 'field.name.label' })}
        type="text"
        fullWidth
      />
      <FormCheckbox sx={{ mt: 2 }} control={control} name="withExpiration" label={intl.formatMessage({ id: 'field.mediaExpiration.label' })} />
      <Stack spacing={2} width={{ xs: '100%', md: '50%' }}>
        <FormDateTimeSelector
          control={control}
          name="availableFrom"
          DateTimePickerProps={{
            disablePast: true,
            disabled: !withExpiration,
            label: intl.formatMessage({ id: 'media.availableFrom' }),
            ampm: false,
          }}
        />
        <FormDateTimeSelector
          control={control}
          name="availableUpTo"
          DateTimePickerProps={{
            disablePast: true,
            disabled: !withExpiration || !availableFrom,
            minDate: availableFrom ? moment(availableFrom) : undefined,
            ampm: false,
            label: intl.formatMessage({ id: 'media.availableUpTo' }),
          }}
        />
      </Stack>
    </Form>
  );
};

export default MediaForm;
